/*
  Floow-Buybox: Zusatzprodukt (addon_upsell, z. B. Daily Bottle) in den Preisen mitrechnen.

  Sobald im Zusatzprodukt-Block eine Menge > 0 gewählt ist, zeigen
    - oben der Preis-Block (.floow-price: aktueller Preis + Streichpreis),
    - die Kaufoptionen-Kachel „Einmalkauf“ (Preis aus data-floow-meta) und
    - die Appstle-Bundle-Summe (.ab-fixed-pricing-price-footer-price-group, aktuell per CSS ausgeblendet)
  den Preis inkl. Zusatzprodukt (Menge × Stückpreis).

  Die Abo-Kachel behält ihren Monatspreis – das Zusatzprodukt wird nur einmal mitbestellt, nicht jeden
  Monat. Stattdessen steht direkt unter „Monatliches Abo“ (im weißen Teil der Kachel) eine Zeile
  „+ 1× Daily Bottle einmalig +19,95 € …“.

  Preis-Block oben: wird immer über data-floow-total angezeigt und zählt bei Änderungen (Variante 4er/6er,
  Zusatzprodukt, Kaufoption) kurz zum neuen Wert, statt zu springen. Weil die Buybox den Block bei jedem
  Variantenwechsel neu rendert, läuft das Update synchron im MutationObserver (vor dem nächsten Paint) –
  so blitzt der Originalpreis nie auf. Die Animation läuft per setTimeout statt requestAnimationFrame,
  damit sie auch in Hintergrund-Tabs zu Ende läuft und nie auf einem Zwischenwert stehen bleibt.

  Zusatzprodukt-Zeilen werden gemerkt: Appstle baut sein Widget beim Variantenwechsel neu auf, dabei
  hängt der Zusatzprodukt-Block kurz nicht im Dokument (die Buybox setzt ihn danach wieder ein). Über die
  gemerkte Referenz bleibt die Menge lesbar, der Preis zählt nicht kurz zurück. Pro Variante zählt nur
  eine Zeile (eine im Dokument hängende hat Vorrang), damit nichts doppelt gerechnet wird.

  Die Original-Werte bleiben unangetastet: Preis-Sync der Buybox und Appstle (React) schreiben sie
  laufend neu. Die Anzeige steht in data-floow-total bzw. data-floow-meta-total und ersetzt das Original
  per CSS (::after, daily-custom.css). Das Script schreibt nur diese Attribute und seine eigene
  Hinweiszeile – keine Schleifen mit den anderen Observern.

  Eingebunden in layout/theme.liquid, läuft nur auf Seiten mit Zusatzprodukt-Block.
*/
(function () {
  var TWEEN_MS = 400;
  var FRAME_MS = 16;
  var PRICE_AT_END = /(\d[\d.]*,\d{2})\s*€\s*$/;

  var parseCents = function (text) {
    var digits = String(text || '').replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  };
  var formatMoney = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  // Gewählte Zusatzprodukte: [{ qty, name, cents }]
  var observer;
  var rows = [];
  var collectRows = function () {
    document.querySelectorAll('[data-floow-addon-row]').forEach(function (row) {
      if (rows.indexOf(row) !== -1) return;
      rows.push(row);
      // data-count ändert sich evtl. auch, während der Block kurz ausgehängt ist
      if (observer) observer.observe(row, { attributes: true, attributeFilter: ['data-count'] });
    });
    var byVariant = {};
    rows.forEach(function (row) {
      var key = row.getAttribute('data-variant');
      var current = byVariant[key];
      if (!current || (!current.isConnected && row.isConnected)) byVariant[key] = row;
    });
    return Object.keys(byVariant).map(function (key) { return byVariant[key]; });
  };
  var addons = function () {
    var list = [];
    collectRows().forEach(function (row) {
      var qty = parseInt(row.getAttribute('data-count'), 10) || 0;
      if (!qty) return;
      var priceEl = row.querySelector('.floow-mix__upsell-price');
      var titleEl = row.querySelector('.floow-mix__flavor-title');
      list.push({
        qty: qty,
        name: titleEl ? titleEl.textContent.trim() : 'Zusatzprodukt',
        cents: qty * parseCents(priceEl && priceEl.textContent)
      });
    });
    return list;
  };

  var setOrRemove = function (el, name, value) {
    if (!value) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
    } else if (el.getAttribute(name) !== value) {
      el.setAttribute(name, value);
    }
  };

  var show = function (el, text) {
    // Schriftgröße merken, bevor die CSS-Regel den Originaltext auf 0 setzt
    if (!el.hasAttribute('data-floow-total')) el.style.setProperty('--floow-total-size', getComputedStyle(el).fontSize);
    setOrRemove(el, 'data-floow-total', text);
  };

  // Element, dessen Text ein Preis ist (Appstle-Summe): ohne Zusatzprodukt Original anzeigen
  var apply = function (el, extra) {
    var base = parseCents(el.textContent);
    if (!extra || !base) return setOrRemove(el, 'data-floow-total', '');
    show(el, formatMoney(base + extra));
  };

  // Preis-Block oben: immer überlagert, Wertwechsel werden animiert.
  // Das Element wird bei Variantenwechsel ersetzt, daher pro Schritt neu suchen.
  var tweens = {};
  var priceEl = function (selector) {
    return document.querySelector('.floow-price[data-floow-price-plans] ' + selector);
  };
  var tweenPrice = function (selector, extra) {
    var el = priceEl(selector);
    if (!el) return;
    var base = parseCents(el.textContent);
    var state = tweens[selector];
    if (!base) {
      setOrRemove(el, 'data-floow-total', '');
      if (state) {
        clearTimeout(state.timer);
        state.target = null;
      }
      return;
    }
    var target = base + extra;
    if (!state || state.target == null) {
      tweens[selector] = { shown: target, target: target };
      return show(el, formatMoney(target));
    }
    if (state.target === target) {
      // z. B. neu gerendertes Element: sofort den aktuell angezeigten Wert übernehmen
      return show(el, formatMoney(state.shown));
    }
    clearTimeout(state.timer);
    var from = state.shown;
    var started = Date.now();
    state.target = target;
    show(el, formatMoney(from));
    var step = function () {
      var t = Math.min(1, (Date.now() - started) / TWEEN_MS);
      var eased = 1 - Math.pow(1 - t, 3);
      state.shown = t < 1 ? Math.round(from + (target - from) * eased) : target;
      var current = priceEl(selector);
      if (current) show(current, formatMoney(state.shown));
      if (t < 1) state.timer = setTimeout(step, FRAME_MS);
    };
    state.timer = setTimeout(step, FRAME_MS);
  };

  var isPlan = function (el) {
    return (el.getAttribute('data-floow-label') || '') !== 'Einmalkauf';
  };

  // Einmalkauf-Kachel: data-floow-meta = "53,82 €" -> Betrag erhöhen. Abo-Kacheln bleiben beim Monatspreis.
  var applyMeta = function (el, extra) {
    var meta = el.getAttribute('data-floow-meta') || '';
    var match = extra && !isPlan(el) ? meta.match(PRICE_AT_END) : null;
    if (!match) return setOrRemove(el, 'data-floow-meta-total', '');
    setOrRemove(el, 'data-floow-meta-total', meta.slice(0, match.index) + formatMoney(parseCents(match[1]) + extra));
  };

  // Abo-Kachel: Hinweis direkt unter dem Titel, vor der Häkchen-Liste
  var applyPlanNote = function (label, items) {
    var radio = label.closest('.ab-fixed-pricing-purchase-options-radio');
    if (!radio) return;
    var note = radio.querySelector(':scope > .floow-po-addon-note');
    if (!items.length) {
      if (note) note.remove();
      return;
    }
    var monthly = (label.getAttribute('data-floow-meta') || '').match(PRICE_AT_END);
    var text = items.map(function (a) { return a.qty + '× ' + a.name + ' einmalig +' + formatMoney(a.cents); }).join(', ') +
      ' – nur in der ersten Lieferung' + (monthly ? ', danach ' + monthly[1] + ' € / Monat' : ', nicht monatlich');
    if (!note) {
      note = document.createElement('p');
      note.className = 'floow-po-addon-note';
    }
    if (note.previousElementSibling !== label) label.insertAdjacentElement('afterend', note);
    if (note.textContent !== text) note.textContent = text;
  };

  var update = function () {
    var items = addons();
    var extra = items.reduce(function (sum, a) { return sum + a.cents; }, 0);
    tweenPrice('[data-floow-price-current]', extra);
    tweenPrice('[data-floow-price-compare-value]', extra);
    document.querySelectorAll('[data-floow-po] [data-floow-meta]').forEach(function (el) {
      applyMeta(el, extra);
    });
    document.querySelectorAll('[data-floow-po] .ab-fixed-pricing-purchase-options-radio-label[data-floow-meta]').forEach(function (el) {
      if (isPlan(el)) applyPlanNote(el, items);
    });
    document.querySelectorAll('.ab-fixed-pricing-price-footer-price-group > *').forEach(function (el) {
      if (/\d/.test(el.textContent)) apply(el, extra);
    });
  };

  var start = function () {
    if (!document.querySelector('[data-floow-addon-row]')) return;
    // Synchron (Microtask vor dem Paint). Beobachtet werden Text/DOM sowie Menge und Kachel-Preis;
    // die eigenen Attribute (data-floow-total, data-floow-meta-total) lösen nichts aus.
    observer = new MutationObserver(update);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-count', 'data-floow-meta']
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
